var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatAlt = function SvgChatAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M17 4.75v7a1.75 1.75 0 0 1-1.75 1.75h-4.375L6.5 17v-3.5H4.75A1.75 1.75 0 0 1 3 11.75v-7C3 3.784 3.784 3 4.75 3h10.5c.966 0 1.75.784 1.75 1.75M7.375 7.375h-1.75v1.75h1.75zm1.75 0h1.75v1.75h-1.75zm5.25 0h-1.75v1.75h1.75z",
    clipRule: "evenodd"
  })));
};
export default SvgChatAlt;